<template>
    <a :href="url" v-if="isExternalLink" >
            <span class="icon-holder">
                <i :class="classIcon"></i>
            </span>
        <span class="title">{{name}}</span>
    </a>
    <router-link :to="url" v-else v-on:click.native="toggle_active" >
            <span class="icon-holder">
                <i :class="classIcon"></i>
            </span>
        <span class="title">{{name}}</span>
    </router-link>
</template>

<script>
    export default {
        name: 'side-nav-link',
        props: {
            name: {
                type: String,
                default: ''
            },
            url: {
                type: String,
                default: ''
            },
            icon: {
                type: String,
                default: ''
            }
        },
        computed: {
            classIcon () {
                return [
                    this.icon
                ]
            },
            isExternalLink () {
                if (this.url.substring(0, 4) === 'http') {
                    return true
                } else {
                    return false
                }
            }
        },
        methods: {
            toggle_active () {
                
                if (this.$parent.$el.classList.contains('active')) {
                    this.$parent.$el.classList.remove('active');
                } else {
                    this.$parent.$el.classList.add('active');
                }

            }
        }
    }
</script>